<template>
  <div class="form-group">
    <label :for="config.id">
      {{ config.label }}
    </label>
    <div class="input-wrapper">
      <select
        :id="config.id"
        v-model="quantity"
        :disabled="disabled"
        class="form-control"
      >
        <option
          value="0"
          selected
        >
          0
        </option>
        <option
          v-for="n in config.maxQuantity"
          :key="n"
          :value="n"
        >
          {{ n }}
        </option>
      </select>
      <i class="icon--arrow-dropdown float-right input-icon" />
    </div>
  </div>
</template>

<script>
export default {
    name: 'ProductRequirement',
    props: {
        config: {
            type: Object,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        quantity: {
            get () {
                return (this.$store.getters['product/getRequirement'](this.config.id)).quantity
            },
            set (value) {
                if (!this.disabled) {
                    this.$store.commit('product/setRequirement', {
                        id: this.config.id,
                        quantity: parseInt(value)
                    })
                }
            }
        }
    },
    watch: {
        disabled () {
            if (this.disabled) {
                this.quantity = 0
            }
        }
    }
}
</script>
